<div *ngIf="isApiCalling" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>
<form [formGroup]="serviceNearDetailForm">
    <div id="main">
        
        <div class="page-tab-container">
            <div class="d-flex justify-content-between px-2">
                <div (click)="changePage(1)" class="py-2">
                    <div class="page-tabs"
                        [ngStyle]="page==1 ? {'background-color':'#673AB7', 'color':'#fff' } : {'color':'#888888'}">
                        Job Details
                    </div>
                </div>
                <div (click)="changePage(2)" class="py-2">
                    <div class="page-tabs"
                        [ngStyle]="page==2 ? {'background-color':'#673AB7', 'color':'#fff'} : {'color':'#888888'}">
                        Work Status
                    </div>
                </div>
                <div [class.disabled-section]="!isCostAndPaymentEnabledSeller" (click)="changePage(3)" class="py-2">
                    <div class="page-tabs"
                        [ngStyle]="page==3 ? {'background-color':'#673AB7', 'color':'#fff'} : {'color':'#888888'}">
                        Cost & Payment
                    </div>
                </div>

            </div>
        </div>
        <div *ngIf="isLoading">
            <div class="px-3 pt-2 d-flex flex-column" style="gap: 16px;">
                <div class="skeleton skeleton-text" style="width: 50%; height: 24px;"></div>

                <!-- Dropdown Skeleton -->
                <div class="skeleton" style="height: 40px; width: 100%; border-radius: 4px;"></div>

                <!-- Assigned Person Skeleton -->
                <div class="skeleton" style="height: 40px; width: 100%; border-radius: 4px;"></div>

                <!-- Textarea skeletons -->
                <div class="skeleton" style="height: 60px; width: 100%; border-radius: 4px;"></div>
                <div class="skeleton" style="height: 60px; width: 100%; border-radius: 4px;"></div>

                <!-- Buttons -->
                <div class="d-flex" style="gap: 10px;">
                    <div class="skeleton" style="height: 40px; width: 40%; border-radius: 4px;"></div>
                    <div class="skeleton" style="height: 40px; width: 60%; border-radius: 4px;"></div>
                </div>
            </div>

            <!-- LOGS SKELETON -->
            <div class="px-3 pt-3">
                <div class="skeleton skeleton-text" style="width: 50%; height: 20px;"></div>
                <div *ngFor="let i of [1,2,3]" class="log-card p-4 my-2">
                    <div class="skeleton-line skeleton" style="width: 40%"></div>
                    <div class="skeleton-line skeleton" style="width: 90%"></div>
                    <div class="skeleton-line skeleton" style="width: 60%"></div>
                </div>
            </div>
        </div>
        <div *ngIf="!isLoading" class="pb-2" style="background-color: #fff;min-height: 100%">
            <div *ngIf="page==1">
                <div *ngIf="currentAssignedUser" class="d-flex justify-content-between mt-0 mx-0 log-card"
                    style="font-size: 0.9rem;border-radius: 2px;padding: 4px 12px;">
                    <span class="text-gray-700">Assigned Person:</span>
                    <span>
                        {{ currentAssignedUser }}
                    </span>
                </div>
                <div class="py-2 px-3" style="position: relative;">
                    <div *ngIf="this.privilegeService.getServicenearPrivilege('editJob',true)"
                        class="d-flex align-items-center justify-content-end pt-2 px-3" style="position: absolute;
                        right: 0; top: 0;">
                        <button class="ml-1" [ngClass]="isEditMode ? 'cancel-btn': 'edit-btn' "
                            (click)="toggleJobDetailsEditMode()">
                            {{ isEditMode ? 'Cancel' : 'Edit' }}
                        </button>
                        <button (click)="updateWorkOrder()" class="edit-btn ml-1" *ngIf="isEditMode" [disabled]="serviceNearDetailForm.get('jobDetailFormGroup')?.invalid" >Save</button>
                    </div>
                    <ng-container *ngIf="!isEditMode">
                        <div formGroupName="jobDetailFormGroup" class="input-container d-flex flex-column "
                            style="row-gap: 16px;">
                            <span class="section-title">
                                Device Details
                            </span>
                            <div class="d-flex flex-column">
                                <label for="billNo">Job No</label>
                                <input class="input-field" formControlName="WorkCode" id="billNo"
                                    aria-describedby="billNo-help" style=" pointer-events: none; opacity: 0.7;" />
                            </div>
                            <div class="d-flex flex-column">
                                <label for="deviceType">Device type</label>
                                <input class="input-field" formControlName="DeviceType" id="deviceType"
                                    style=" pointer-events: none; opacity: 0.7;" />
                            </div>
                            <div class="d-flex flex-column">
                                <label for="brand">Brand</label>
                                <input class="input-field" formControlName="Manufacture" id="brand"
                                    aria-describedby="brand-help" style=" pointer-events: none; opacity: 0.7;" />

                            </div>
                            <div class="d-flex flex-column">
                                <label for="modelName">Model name</label>
                                <input class="input-field" formControlName="ModelName" id="modelName"
                                    aria-describedby="modelName-help" style=" pointer-events: none; opacity: 0.7;" />
                            </div>
                            <div class="d-flex flex-column">
                                <label class="field-label" for="imei">IMEI No.</label>
                                <input class="input-field" formControlName="IMEI" id="imei"
                                    aria-describedby="imei-help" style=" pointer-events: none; opacity: 0.7;" />
                            </div>

                            <div class="d-flex flex-column">
                                <div class="d-flex mb-2" style="gap: 0.5rem;">
                                    <div (click)="changePatternOrPassword(2)" class="">
                                        <div class="pb-1" [ngStyle]="pass==2 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                                            <label class="field-label mb-0" for="pattern" [ngStyle]="pass==2 ? {'color':'#000'} : {'color':'#888888'}">Password</label>
                                        </div>
                                    </div>
                                    <div (click)="changePatternOrPassword(1)" class="">
                                        <div class="pb-1" [ngStyle]="pass==1 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                                            <label class="field-label mb-0" for="pattern" [ngStyle]="pass==1 ? {'color':'#000'} : {'color':'#888888'}">Pattern</label>
                                        </div>
                                    </div>
                                </div>
                                <div [ngClass]="{ 'active-tab': pass === 2, 'hidden-tab': pass !== 2 }">
                                    <input class="input-field" formControlName="Pattern" style=" pointer-events: none; opacity: 0.7;"/>
                                </div>
                                <div  [ngClass]="{ 'active-tab': pass === 1, 'hidden-tab': pass !== 1 }">
                                    <ngx-pattern-lock #patternLock [readonly]="true" [preloadedPattern]="this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.value">
                                    </ngx-pattern-lock>
                                </div>
                            </div>

                            <div class="d-flex flex-column">
                                <label for="issueDescription">Issue description</label>
                                <textarea class="textarea-field" style=" pointer-events: none; opacity: 0.7;"
                                    formControlName="WorkDescription" rows="3" cols="30">
                                </textarea>
                            </div>
                            <div class="d-flex flex-column" formGroupName="accessories">
                                <label for="deviceColor">Device color</label>
                                <input class="input-field" id="deviceColor" formControlName="color"
                                    aria-describedby="deviceColor-help" style=" pointer-events: none; opacity: 0.7;" />
                            </div>
                            <div class="d-flex flex-column">
                                <label for="deliveryDate">To be delivered on</label>
                                <input class="input-field form-control delivery-date" type="text" id="deliveryDate"
                                    [placeholder]="formttedDeliveryDate"
                                    style=" pointer-events: none; opacity: 0.7; height: auto;" />

                            </div>
                            <div class="d-flex flex-column" formGroupName="accessories">
                                <label for="remarks">Remarks</label>
                                <textarea class="textarea-field" style=" pointer-events: none; opacity: 0.7;"
                                    formControlName="remarks" id="remarks" rows="3" cols="30">
                                </textarea>
                            </div>

                            <div class="input-container d-flex flex-column" formGroupName="accessories">
                                <label for="accessoriesMissing">Accessories Provided</label>

                                <div class="d-flex flex-wrap mt-2"
                                    style="gap: 15px; pointer-events: none; opacity: 0.7">
                                    <div *ngFor="let item of providedArray" class="checkbox-container">
                                        <input class="custom-checkbox" type="checkbox" id="{{ item.value }}Checkbox"
                                            [formControlName]="item.value">
                                        <label class="mb-0" for="{{ item.value }}Checkbox">{{ item.label }}</label>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="input-container d-flex flex-column" formGroupName="accessories">
                                <label for="accessoriesMissing">Accessories Missing</label>
                                <div class="d-flex flex-wrap mt-2"
                                    style="row-gap: 14px; column-gap: 12px;pointer-events: none; opacity: 0.7">

                                    <div *ngFor="let item of missingArray"class="checkbox-container">
                                        <input class="custom-checkbox" type="checkbox" id="{{ item.value }}Checkbox"
                                            [formControlName]="item.value">
                                        <label class="mb-0" for="{{ item.value }}Checkbox">{{ item.label }}</label>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="serviceNearDetailForm.get('jobDetailFormGroup.AssignedUser')?.value"
                                class="d-flex flex-column w-100">
                                <div class="divider mt-2"></div>
                                <label for="remarks">Assigned Person</label>
                                <input class="input-field"
                                    [formControl]="serviceNearDetailForm.get('jobDetailFormGroup.AssignedUser')"
                                    id="modelName" aria-describedby="modelName-help"
                                    style=" pointer-events: none; opacity: 0.7;" />
                            </div>

                            <span class="section-title" style="margin-bottom: 5px;">
                                Cost
                            </span>

                            <div class="d-flex justify-content-between " style="gap: 1rem">
                                <div class="d-flex flex-column">
                                    <label for="minServiceCost">Min. Service Cost</label>
                                    <input class="input-field" formControlName="MinServiceCost" id="minServiceCost"
                                        style=" pointer-events: none; opacity: 0.7;" />
                                </div>
                                <div class="d-flex flex-column">
                                    <label for="maxServiceCost">Max. Service Cost</label>
                                    <input class="input-field" formControlName="MaxServiceCost" id="maxServiceCost"
                                        style=" pointer-events: none; opacity: 0.7;" />
                                </div>
                            </div>
                            <!-- <div class="d-flex flex-column">
                                <label for="PartialPayment">Advance Collected</label>
                                <input class="input-field" formControlName="AdvanceServiceCost" id="PartialPayment"
                                    style=" pointer-events: none; opacity: 0.7;" />
                            </div> -->

                            <ng-container *ngIf="this.jobDetails[0]?.ShopName !== ''">
                                <span class="section-title">
                                    Shop Details
                                </span>

                                <div class="d-flex flex-column">
                                    <label for="customerName">Shop Name</label>
                                    <input class="input-field" id="customerName" formControlName="ShopName"
                                        [readonly]="true" [attr.disabled]="true"
                                        style="box-shadow: none; opacity: 0.65;pointer-events: none;" />
                                </div>
                                <div class="d-flex flex-column">
                                    <label for="customerNumber">Contact Number</label>
                                
                                    <div class="input-group">
                                        <input class="form-control" formControlName="ContactNo" id="customerNumber" 
                                            style="opacity: 0.65; box-shadow: none; pointer-events: none;" />
                                
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary" type="button" (click)="copyContactNumber()">
                                                <i class="fa fa-copy"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </ng-container>
                            <ng-container *ngIf="this.jobDetails[0]?.ShopName === ''">
                                <span class="section-title">
                                    Customer Details
                                </span>
                                <div class="d-flex flex-column">
                                    <label for="customerName">Customer Name</label>
                                    <input class="input-field" id="customerName" formControlName="ContactPerson"
                                        style=" pointer-events: none; opacity: 0.7;" />
                                </div>
                                <div class="d-flex flex-column">
                                    <label for="customerNumber">Contact Number</label>
                                
                                    <div class="input-group">
                                        <input class="form-control" formControlName="ContactNo" id="customerNumber"
                                            style="opacity: 0.65; box-shadow: none; pointer-events: none;" />
                                
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary" type="button" (click)="copyContactNumber()">
                                                <i class="fa fa-copy"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- EDIT FORM  -->
                    <ng-container *ngIf="isEditMode">
                        <div class="input-container d-flex flex-column " style="row-gap: 16px;"
                            formGroupName="jobDetailFormGroup">
                            <span class="section-title">
                                Device Details
                            </span>
                            <div class="d-flex flex-column">
                                <label for="billNo">Bill No</label>
                                <input class="input-field" formControlName="WorkCode" id="billNo"
                                    aria-describedby="billNo-help" [readonly]="true" [attr.disabled]="true"
                                    style="box-shadow: none; opacity: 0.65;pointer-events: none;" />
                            </div>
                            <div class="d-flex flex-column">
                                <label for="deviceType">Device type</label>
                                <ng-select formControlName="DeviceType" id="deviceType" [items]="deviceTypes"
                                    bindLabel="DeviceType" bindValue="DeviceType" [addTag]="addDeviceTypeTagFn"
                                    [searchable]="true" [clearable]="true" [closeOnSelect]="true" [openOnEnter]="false"
                                    [selectOnTab]="false">
                                    <ng-template let-search="searchTerm">
                                        <span>Add: "{{search}}"</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                            <div class="d-flex flex-column">
                                <label for="brand">Brand</label>
                                <ng-select formControlName="Manufacture" id="brand" [items]="phoneNames"
                                    bindLabel="ManufactureName" bindValue="ManufactureName"
                                    [addTag]="addPhoneNamesTagFn" [searchable]="true" [clearable]="true"
                                    [closeOnSelect]="true">
                                    <ng-template let-search="searchTerm">
                                        <span>Add: "{{search}}"</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                            <div class="d-flex flex-column">
                                <label for="modelName">Model name (required)*</label>
                                <ng-select formControlName="ModelName" id="modelName" [items]="modelNames"
                                    bindLabel="ModelName" bindValue="ModelName" [addTag]="addModelNamesTagFn"
                                    [searchable]="true" [clearable]="true" [closeOnSelect]="true">
                                    <ng-template let-search="searchTerm">
                                        <span>Add: "{{search}}"</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                            <div class="d-flex flex-column">
                                <label for="deliveryDate">To be delivered on (required)*</label>
                                <input class="input-field form-control" type="datetime-local"
                                    formControlName="DeliveryDate" id="deliveryDate"
                                    aria-describedby="deliveryDate-help" style="height: auto;" />
                            </div>
                            <div class="d-flex flex-column">
                                <label for="imei">IMEI No.</label>
                                <input class="input-field" formControlName="IMEI" id="imei"
                                    aria-describedby="imei-help" />
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex mb-2" style="gap: 0.5rem;">
                                    <div (click)="changePatternOrPassword(2)" class="">
                                        <div class="pb-1" [ngStyle]="pass==2 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                                            <label class="field-label mb-0" for="pattern" [ngStyle]="pass==2 ? {'color':'#000'} : {'color':'#888888'}">Password</label>
                                        </div>
                                    </div>
                                    <div (click)="changePatternOrPassword(1)" class="">
                                        <div class="pb-1" [ngStyle]="pass==1 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                                            <label class="field-label mb-0" for="pattern" [ngStyle]="pass==1 ? {'color':'#000'} : {'color':'#888888'}">Pattern</label>
                                        </div>
                                    </div>
                                </div>
                                <div [ngClass]="{ 'active-tab': pass === 2, 'hidden-tab': pass !== 2 }">
                                    <input class="input-field" formControlName="Pattern" id="pattern" aria-describedby="pattern-help" />
                                </div>
                                <div [ngClass]="{ 'active-tab': pass === 1, 'hidden-tab': pass !== 1 }">
                                    <ngx-pattern-lock #patternLock (patternChange)="onPatternComplete($event)"
                                        [preloadedPattern]="this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.value">
                                    </ngx-pattern-lock>
                                    <div class="d-flex align-items-center w-100 justify-content-center mt-1">
                                        <div class="d-flex align-items-center" >
                                            <button (click)="resetPattern()" type="button" class="pattern-btns btn btn-sm d-inline-flex align-items-center px-4 py-2 font-weight-medium" style="
                                                font-weight: 12px;
                                                background-color: #fff;
                                                color: #dc3545;">
                                                <i class="fa fa-refresh mr-2"></i>
                                                Reset
                                            </button>

                                            <button (click)="revertPattern()" type="button" class="pattern-btns btn btn-sm d-inline-flex align-items-center px-4 py-2 font-weight-medium" style="
                                                font-weight: 12px;
                                                background-color: #fff;
                                                color: #64748B;">
                                                <i class="fa fa-redo mr-2"></i>
                                                Revert
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <label for="issueDescription">Issue description (required)*</label>
                                <textarea class="textarea-field" formControlName="WorkDescription" rows="3" cols="30">
                                </textarea>
                            </div>
                            <div class="d-flex flex-column" formGroupName="accessories">
                                <label for="deviceColor">Device color</label>
                                <input class="input-field" id="deviceColor" formControlName="color"
                                    aria-describedby="deviceColor-help" />
                            </div>
                            <div class="d-flex flex-column" formGroupName="accessories">
                                <label for="remarks">Remarks</label>
                                <textarea class="textarea-field" formControlName="remarks" id="remarks" rows="3"
                                    cols="30">
                                </textarea>
                            </div>
                            <div class="input-container d-flex flex-column" formGroupName="accessories">
                                <label for="accessoriesMissing">Accessories Provided</label>
                                <div class="d-flex flex-wrap mt-2" style="gap: 15px;">
                                    <div *ngFor="let item of providedArray" class="checkbox-container">
                                        <input class="custom-checkbox" type="checkbox" id="{{ item.value }}Checkbox"
                                            [formControlName]="item.value">
                                        <label class="mb-0" for="{{ item.value }}Checkbox">{{ item.label }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="input-container d-flex flex-column" formGroupName="accessories">
                                <label for="accessoriesMissing">Accessories Missing</label>
                                <div class="d-flex flex-wrap mt-2" style="row-gap: 14px; column-gap: 12px;">

                                    <div *ngFor="let item of missingArray"class="checkbox-container">
                                        <input class="custom-checkbox" type="checkbox" id="{{ item.value }}Checkbox"
                                            [formControlName]="item.value">
                                        <label class="mb-0" for="{{ item.value }}Checkbox">{{ item.label }}</label>
                                    </div>
                                </div>
                            </div>
                            <!-- Assigned User on Edit Mode -->
                            <div class="d-flex flex-column">
                                <div class="divider mt-2"></div>
                                <label for="remarks">Assigned Person</label>
                                <ng-select placeholder="Select user" [items]="userList" bindValue="Name"
                                    bindLabel="Name"
                                    [formControl]="serviceNearDetailForm.get('jobDetailFormGroup.AssignedUser')"
                                    [closeOnSelect]="true" [searchable]="true" [clearable]="true">
                                </ng-select>
                            </div>

                            <span class="section-title">
                                Cost
                            </span>

                            <div class="d-flex justify-content-between " style="gap: 1rem">
                                <div class="d-flex flex-column">
                                    <label for="minServiceCost">Min. Service Cost</label>
                                    <input class="input-field" formControlName="MinServiceCost" id="minServiceCost" />
                                </div>
                                <div class="d-flex flex-column">
                                    <label for="maxServiceCost">Max. Service Cost</label>
                                    <input class="input-field" formControlName="MaxServiceCost" id="maxServiceCost" />
                                </div>
                            </div>
                            <!-- <div class="d-flex flex-column">
                                <label for="PartialPayment">Advance Collected</label>
                                <input class="input-field" formControlName="AdvanceServiceCost" id="PartialPayment" />
                            </div> -->
                            <ng-container *ngIf="this.jobDetails[0]?.ShopName !== ''">
                                <span class="section-title">
                                    Shop Details
                                </span>

                                <div class="d-flex flex-column">
                                    <label for="customerName">Shop Name</label>
                                    <input class="input-field" id="customerName" formControlName="ShopName"
                                        [readonly]="true" [attr.disabled]="true"
                                        style="box-shadow: none; opacity: 0.65;pointer-events: none;" />
                                </div>
                                <div class="d-flex flex-column">
                                    <label for="customerNumber">Contact Number</label>
                                    <input class="input-field" formControlName="ContactNo" id="customerNumber"
                                        [readonly]="true" [attr.disabled]="true"
                                        style="box-shadow: none; opacity: 0.65;pointer-events: none;" />
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.jobDetails[0]?.ShopName === ''">
                                <span class="section-title">
                                    Customer Details
                                </span>
                                <div class="d-flex flex-column">
                                    <label for="customerName">Customer Name</label>
                                    <input class="input-field" id="customerName" formControlName="ContactPerson" />
                                </div>
                                <div class="d-flex flex-column">
                                    <label for="customerNumber">Contact Number</label>
                                    <input class="input-field" formControlName="ContactNo" id="customerNumber" />
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="page==2">
                <div [ngClass]="this.privilegeService.getServicenearPrivilege('editStatus',true) ? '' : 'access-denied' "
                    class="px-3 pt-2 d-flex flex-column justify-content-between"
                    [ngStyle]="{'pointer-events': isStatusInaccessible ? 'none' : 'auto', 'opacity': isStatusInaccessible ? '0.5' : '1' }">
                    <span class="section-title" style="margin-bottom: 10px;">
                        Change Work Status
                    </span>
                    <div formGroupName="workStatusFormGroup" style="height: 100%;"
                        class="input-container d-flex flex-column justify-content-between" style="row-gap: 16px;">

                        <div class="d-flex flex-column">
                            <label for="workStatus">Click here to change status</label>

                            <ng-select placeholder="Select status" [items]="filteredStatusList" bindValue="Status"
                                [bindDisabled]="disabled" bindLabel="Status" formControlName="WorkStatus"
                                [searchable]="true" [clearable]="false">
                            </ng-select>

                        </div>

                        <div *ngIf="(jobDetails.length > 0) && ( serviceNearDetailForm.get('workStatusFormGroup.WorkStatus')?.value === 'In Progress' )"
                            class="d-flex flex-column">
                            <label for="remarks">Assigned Person</label>

                            <ng-select placeholder="Select user" [items]="userList" bindValue="Name" bindLabel="Name"
                                formControlName="AssignedUser" [searchable]="true" [clearable]="true">
                            </ng-select>

                        </div>

                        <div class="d-flex flex-column">
                            <label for="remarks">Current Status of Device</label>
                            <textarea class="textarea-field" formControlName="currentStatusOfDevice" id="remarks"
                                rows="2" cols="30">
                            </textarea>
                        </div>
                        <div class="w-100 d-flex align-items-center " style="gap: 10px; margin-top: 10px;">
                            <button class=" w-40 d-flex justify-content-center py-2" (click)="handleDiscard()"
                                [disabled]="!isWorkStatusFormChanged()"
                                style="background-color: #fff;color: #444050; border: 1px solid #444050; border-radius: 4px;">
                                Discard
                            </button>
                            <button (click)="udpateWorkStatus()" class=" w-60 d-flex justify-content-center py-2"
                                [disabled]="serviceNearDetailForm.get('workStatusFormGroup')?.invalid"
                                style="background-color: #28a745;color: #fff; border: 1px solid #28a745;border-radius: 4px;">
                                Change
                            </button>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="section">
                    <div class="px-3 py-1 d-flex align-items-center justify-content-between ">
                        <div class="d-flex justify-content-center align-items-center">
                            <span class="section-title">
                                Job Status Logs
                            </span>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                            <span style="color: #444050; font-size: 10px; font-weight: 400; margin-right: 5px;">Status
                                Only</span>
                            <label class="switch">
                                <input formControlName="statusOnly" class="input-switch" type="checkbox">
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                    <div *ngIf="isLoading" class="d-flex align-items-center justify-content-center p-3"
                        [ngStyle]="{ height: (jobDetails.length > 0 && ( jobDetails[0]?.AssignedUser !== '' || jobDetails[0]?.WorkStatus === 'In Progress')) ? '82%' : '85%' }">
                        <div
                            class=" bg-purple-100 border-round w-12 h-full flex justify-content-center align-items-center">
                            <i class="pi pi-spin pi-spinner"></i>
                            Loading...
                        </div>
                    </div>
                    <div *ngIf="!isLoading" class="px-3">
                        <ng-container *ngFor="let job of jobDetails">
                            <div class="log-card p-2 my-2" style="border-radius: 4px;">
                                <div class="d-flex align-items-center">
                                    <span class=" mr-2" style="font-size: 13px;">Status: </span>
                                    <span class="log-card-title">{{ job.TrackStatus }}</span>
                                </div>
                                <div class="d-flex flex-column" *ngIf="!serviceNearDetailForm.get('statusOnly')?.value">
                                    <span class="" style="font-size: 13px;">Updated Message</span>
                                    <span class="log-card-title">{{ job.ServiceDescription }}</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class=" mr-2" style="font-size: 13px;">Updated by: </span>
                                    <span class="log-card-title">
                                        {{ job.Username }} - {{ job.TrackDate | date: 'MMM d y h:mm a' }}
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div [class.disabled-section]="!isCostAndPaymentEnabledSeller" *ngIf="page==3">
                <ng-container *ngIf="!privilegeService.getServicenearPrivilege('hideCostAndPayment', false)">
                    <div *ngIf="orderTransactions.displayOrderTransactionList">
                        <div class="d-flex align-items-center justify-content-between bg-white px-3 py-1">
                            <div class="btn btn-link p-0 text-dark d-flex align-items-center justify-content-between w-100">
                                <h6 class="m-0 text-dark font-weight-bold">Transactions</h6>
                                <i class="bi bi-x" (click)="closeTransactionList()"
                                    style="font-size: 20px; color:#808080; opacity: 0.6;"></i>
                            </div>
                        </div>
                        <div class="pt-2">
                            <div *ngIf="orderTransactions.isTransactionLoading"
                                class="d-flex justify-content-center align-items-center bg-white p-3">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </div>
                            <div *ngIf="orderTransactions.transactionsList.length === 0"
                                class="text-center text-muted py-3">
                                No Data Listed
                            </div>
                            <div *ngIf="!orderTransactions.isTransactionLoading && orderTransactions.transactionsList.length > 0"
                                class="transaction-list px-3">
                                <div *ngFor="let transaction of orderTransactions.transactionsList"
                                    class="card border rounded transaction-card mb-2">
                                    <div class="card-body py-2 px-2">
                                        <div class="d-flex justify-content-between flex-wrap">
                                            <small class="text-secondary">
                                                <strong>Transaction Type:</strong> {{ transaction.TransactionType }}
                                            </small>
                                            <small class="text-muted">
                                                {{ getUnixFormatedTime(transaction.TransactionDate) }}
                                            </small>
                                        </div>
                                        <div class="d-flex justify-content-between flex-wrap">
                                            <div class="font-weight-bold text-dark">
                                                Amount: ₹{{ transaction.Amount }}
                                            </div>
                                            <small class="text-secondary">
                                                <strong>Payment Mode:</strong> {{ transaction.PaymentMode }}
                                            </small>
                                        </div>
                                        <div class="text-secondary small">
                                            <strong>Narration:</strong> {{ transaction.Narration || '-' }}
                                        </div>
                                        <div class="text-secondary small">
                                            <strong>Ledger Name:</strong> {{ transaction.LedgerName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div *ngIf="!orderTransactions.displayOrderTransactionList" [formGroup]="billForm"
                        class="px-3 pt-2 pb-3 d-flex flex-column justify-content-start" style="gap: 1rem;">
                        <div id="accordion" class="d-flex flex-column" style="gap: 1rem;">
                            <div class="card">
                                <div class="card-header">
                                    <a class="collapsed card-link d-flex justify-content-between" data-toggle="collapse"
                                        href="#collapseTwo"
                                        (click)="isPartsOpen = !isPartsOpen;isServiceOpen=false;isPaymentOpen=false;">
                                        <div class="text-dark">Parts</div>
                                        <div class="d-flex justify-content-between" style="gap: 1rem">
                                            <div style="color: #673AB7;">
                                                {{ getTotalInventoryMRP() - partsDiscount |
                                                currency:'INR':'symbol':'1.2-2' }}
                                            </div>
                                            <i class="bi text-dark"
                                                [ngClass]="isPartsOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                                        </div>
                                    </a>
                                </div>
                                <div id="collapseTwo" class="collapse show" data-parent="#accordion">
                                    <div class="card-body d-flex flex-column" style="gap: 1rem;" [ngClass]="{
                                            'access-denied': privilegeService.getServicenearPrivilege('disableCostAndPayment', false),
                                            'disabled-element': isCostAndPayDisabled
                                         }">
                                        <div class="d-flex flex-column" style="gap: 1rem">
                                            <div formArrayName="inventoryProducts"
                                                class="addedProductlist d-flex flex-column">
                                                <ng-container
                                                    *ngFor="let group of inventoryProductsArray.controls; let i = index;"
                                                    [formGroupName]="i">
                                                    <div class="addedProduct d-flex justify-content-between rounded p-1">
    
                                                        <div class=" d-flex justify-content-center align-items-center"
                                                            [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('partsDeleteOnJob', true)}">
                                                            <i class="bi bi-trash text-danger"
                                                                (click)="removeInventoryProduct(group.value, i)"></i>
                                                        </div>
                                                        <div class="d-flex flex-column justify-content-center"
                                                            style="width: 35%;">
                                                            <div class="text-clamp small" style="width: 95%;">
                                                                {{ group.get('ProductName')?.value }}
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-center align-items-center"
                                                            style="width: 10%;">
                                                            <div class="d-flex justify-content-center w-100">
                                                                {{ group.get('QtyInput')?.value }}
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-center align-items-center text-truncate small"
                                                            style="width: 23%;">
                                                            {{ group.get('TotalPrice')?.value |
                                                            currency:'INR':'symbol':'1.2-2'}}
                                                        </div>
    
                                                        <div class="d-flex justify-content-between align-items-center"
                                                            style="gap: 1rem;">
                                                            <div class=" d-flex justify-content-center align-items-center"
                                                                [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('partsEditOnJob', true)}">
                                                                <i class="bi bi-pencil-square text-dark"
                                                                    (click)="editInventoryProduct(group.value, i)"></i>
                                                            </div>
                                                        </div>
    
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between ">
                                                <input formControlName="partsSearch" type="text" class="form-control"
                                                    placeholder="Search & Add Parts..."
                                                    (click)="isPartsDropdownOpen = !isPartsDropdownOpen"
                                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('partsAddOnJob', true)}">
                                                <button type="button" class="btn btn-sm rounded ml-2 "
                                                    (click)="openQuickAddProductForm('inventory')"
                                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('quickProduct', true)}"
                                                    style="background-color:#fff; color:#673AB7; border-color:#673AB7;padding: 4px 12px; font-size: 18px;">
                                                    +
                                                </button>
                                            </div>
                                            <div *ngIf="isPartsDropdownOpen" class="searchDropdown d-flex flex-column">
                                                <ng-container *ngFor="let product of inventoryProducts;">
                                                    <div class="searchDropdownProducts d-flex justify-content-between rounded p-1"
                                                        (click)="addToPartsList(product, $index)"
                                                        [ngClass]="product.AutoOutOfStock && product.Stock<=0? 'disabled-product':'' ">
                                                        <div class="d-flex flex-column justify-content-center w-75">
                                                            <div class="text-truncate small">
                                                                {{ product.ProductName }}
                                                            </div>
                                                            <div class="text-truncate text-secondary"
                                                                style="font-size: 0.8rem;">
                                                                {{ product.CategoryName }}
                                                            </div>
                                                        </div>
                                                        <div *ngIf="product.AutoOutOfStock && product.Stock<=0"
                                                            class="d-flex align-items-center text-muted"
                                                            style="font-size: 0.8rem; color: red !important;">
                                                            No Stock
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <div *ngIf="this.billForm.get('inventoryProducts')!.value.length > 0"
                                                            class="d-flex justify-content-start align-items-center"
                                                            [ngClass]="+this.getTotalInventoryMRP()==0 ? 'disabled-element' : '' " >
                                                            <div style="color: #9c9a9a;">
                                                                Dis :
                                                            </div>
                                                            <div class="input-group w-50 ml-1">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text">₹</span>
                                                                </div>
                                                                <input formControlName="partsDiscount" type="number"
                                                                    placeholder="0" class="form-control"
                                                                    style="text-align: right;" (input)="validatePartsDiscount($event)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="page-tabs"
                                                        style="background-color:#fff; color:#673AB7; border:1px solid #673AB7;width: 30%;"
                                                        (click)="goToServiceAccordion()">
                                                        Next
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header">
                                    <a #serviceToggle class="card-link d-flex justify-content-between"
                                        data-toggle="collapse" href="#collapseOne"
                                        (click)="isServiceOpen = !isServiceOpen;isPartsOpen=false;isPaymentOpen=false;">
                                        <div class="text-dark">Service</div>
                                        <div class="d-flex justify-content-between" style="gap: 1rem">
                                            <div style="color: #673AB7;">
                                                {{ getTotalServiceMRP() - serviceDiscount |
                                                currency:'INR':'symbol':'1.2-2' }}
                                            </div>
                                            <i class="bi text-dark"
                                                [ngClass]="isServiceOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                                        </div>
                                    </a>
                                </div>
                                <div id="collapseOne" class="collapse" data-parent="#accordion">
                                    <div class="card-body d-flex flex-column" style="gap: 1rem;"
                                        [ngClass]="{
                                            'access-denied': privilegeService.getServicenearPrivilege('disableCostAndPayment', false),
                                            'disabled-element': isCostAndPayDisabled
                                         }">
                                        <div class="d-flex flex-column" style="gap: 1rem">
                                            <div formArrayName="serviceProducts"
                                                class="addedProductlist d-flex flex-column">
                                                <ng-container
                                                    *ngFor="let group of serviceProductsArray.controls; let i = index;"
                                                    [formGroupName]="i">
                                                    <div class="addedProduct d-flex justify-content-between rounded p-1">
                                                        <div class=" d-flex justify-content-center align-items-center"
                                                            [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('serviceDeleteOnJob', true)}">
                                                            <i class="bi bi-trash text-danger"
                                                                (click)="removeServiceProduct(group.value, i)"></i>
                                                        </div>
                                                        <div class="d-flex flex-column justify-content-center"
                                                            style="width: 35%;">
                                                            <div class="small text-clamp" style="width: 100%;">
                                                                {{ group.get('ProductName')?.value }}
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-center align-items-center"
                                                            style="width: 10%;">
                                                            <div class="d-flex justify-content-center w-100">
                                                                {{ group.get('QtyInput')?.value }}
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-center align-items-center text-truncate small"
                                                            style="width: 23%;">
                                                            {{ group.get('TotalPrice')?.value |
                                                            currency:'INR':'symbol':'1.2-2'}}
                                                        </div>
                                                        <div class="d-flex justify-content-between align-items-center"
                                                            style="gap: 1rem;">
                                                            <div class=" d-flex justify-content-center align-items-center"
                                                                [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('serviceEditOnJob', true)}">
                                                                <i class="bi bi-pencil-square text-dark"
                                                                    (click)="editServiceProduct(group.value, i)"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between ">
                                                <input formControlName="serviceSearch" type="text" class="form-control"
                                                    placeholder="Search & Add Services..."
                                                    (click)="isServiceDropdownOpen = !isServiceDropdownOpen"
                                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('serviceAddOnJob', true)}">
                                                <button type="button" class="btn btn-sm rounded ml-2 "
                                                    (click)="openQuickAddProductForm('service')"
                                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('quickProduct', true)}"
                                                    style="background-color:#fff; color:#673AB7; border-color:#673AB7;padding: 4px 12px; font-size: 18px;">
                                                    +
                                                </button>
                                            </div>
                                            <div *ngIf="isServiceDropdownOpen" class="searchDropdown d-flex flex-column">
                                                <ng-container *ngFor="let product of serviceProducts;">
                                                    <div class="searchDropdownProducts d-flex justify-content-between rounded p-1"
                                                        (click)="addToServiceList(product, $index)">
                                                        <div class="d-flex flex-column justify-content-center w-75">
                                                            <div class="text-clamp small">
                                                                {{ product.ProductName }}
                                                            </div>
                                                            <div class="text-truncate text-secondary"
                                                                style="font-size: 0.8rem;">
                                                                {{ product.CategoryName }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <div *ngIf="this.billForm.get('serviceProducts')!.value.length > 0"
                                                            class="d-flex justify-content-start align-items-center"
                                                            [ngClass]="+this.getTotalServiceMRP()==0 ? 'disabled-element' : '' ">
                                                            <div style="color: #9c9a9a;">
                                                                Dis :
                                                            </div>
                                                            <div class="input-group w-50 ml-1">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text">₹</span>
                                                                </div>
                                                                <input formControlName="serviceDiscount" type="number"
                                                                    placeholder="0" class="form-control"
                                                                    style="text-align: right;" (input)="validateServiceDiscount($event)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="page-tabs"
                                                        style="background-color:#fff; color:#673AB7; border:1px solid#673AB7;width: 30%;"
                                                        (click)="goToPaymentAccordion()">
                                                        Next
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header">
                                    <a class="collapsed card-link d-flex justify-content-between" data-toggle="collapse"
                                        href="#collapseThree"
                                        (click)="isPaymentOpen = !isPaymentOpen;isPartsOpen=false;isServiceOpen=false;">
                                        <div class="text-dark d-flex align-items-center ">
                                            <div>
                                                Payment
                                            </div>
                                            <div *ngIf="currentOrderStatus"
                                                class="payment-status border rounded d-flex align-items-center justify-content-center ml-2"
                                                style="padding:2px 6px; font-size: 0.6rem;min-width: 50px;" [ngClass]="getStatusClass()">
                                                {{ currentOrderStatus }}
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between" style="gap: 1rem">
                                            <div *ngIf="finalAmount>=0" style="color: #673AB7;">
                                                {{ finalAmount | currency:'INR':'symbol':'1.2-2' }}
                                            </div>
                                            <div *ngIf="finalAmount < 0" style="color: #673AB7;">
                                                ₹ --
                                            </div>
                                            <i class="bi text-dark"
                                                [ngClass]="isPaymentOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                                        </div>
                                    </a>
                                </div>
                                <div id="collapseThree" class="collapse" data-parent="#accordion">
                                    <div class="card-body d-flex flex-column" style="gap: 0.5rem;"
                                        [ngClass]="{
                                            'access-denied': privilegeService.getServicenearPrivilege('disableCostAndPayment', false),
                                            'disabled-element': isCostAndPayDisabled
                                         }">
                                        <div>
    
                                            <div class="d-flex justify-content-between">
                                                <div>Parts Cost: </div>
                                                <div>{{ getTotalInventoryMRP() | currency:'INR':'symbol':'1.2-2'}}</div>
                                            </div>
                                            <div class="d-flex justify-content-between text-danger">
                                                <div>Parts Discount</div>
                                                <div>-{{ partsDiscount | currency:'INR':'symbol':'1.2-2'}}</div>
                                            </div>
    
                                            <div class="d-flex justify-content-between">
                                                <div>Service Cost: </div>
                                                <div>{{ getTotalServiceMRP() | currency:'INR':'symbol':'1.2-2'}}</div>
                                            </div>
                                            <div class="d-flex justify-content-between text-danger">
                                                <div>Service Discount</div>
                                                <div>-{{ serviceDiscount | currency:'INR':'symbol':'1.2-2'}}</div>
                                            </div>
    
                                        </div>
                                        <hr class="w-100 my-1">
    
                                        <div class="d-flex flex-column justify-content-between"
                                            [ngClass]="finalAmountWithoutAdditionalDisc<=0 ? 'disabled-element' : '' ">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    Additional Dis :
                                                </div>
                                                <div class="input-group w-50" [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('editPaymentFields', true)}">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">₹</span>
                                                    </div>
                                                    <input formControlName="customDiscount" type="number" placeholder="0"
                                                        class="form-control" style="text-align: right;" min="0"  (input)="validateAdditionalDiscount($event)">
                                                </div>
                                            </div>
                                        </div>
    
                                        <hr class="w-100 my-1">
    
                                        <div>
                                            <div class="d-flex justify-content-between text-danger">
                                                <div>Total Discount :</div>
                                                <div>{{ totalDiscount | currency:'INR':'symbol':'1.2-2'}}</div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div>Total Cost :</div>
                                                <div>{{ (getTotalServiceMRP() - serviceDiscount) + (getTotalInventoryMRP() -
                                                    partsDiscount) | currency:'INR':'symbol':'1.2-2'}}</div>
                                            </div>
                                        </div>
    
                                        <hr class="w-100 my-1">
    
                                        <div class="d-flex align-items-center justify-content-between text-success"
                                            [ngClass]="isPaidJob?'disabled-element':''">
                                            <div class="">Advance Paid :</div>
                                            <div class="d-flex align-items-center w-50" [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('editPaymentFields', true)}">
                                                <input class="form-control" style="text-align: right;" placeholder="0"
                                                    (click)="showEditAdvanceModal=true" formControlName="newAdvance"
                                                    id="advanceCollected" />
    
                                            </div>
                                        </div>
                                        <hr class="w-100 my-1">
    
                                        <div
                                            class="d-flex flex-column align-items-start justify-content-between font-weight-bold">
                                            <div>Final Amount :</div>
                                            <div class="w-100 d-flex align-items-center"
                                                style="border:1px solid #ced4da;border-radius: .25rem;"
                                                [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('editPaymentFields', true)}">
                                                <div class="input-group input-group-lg flex-grow-1 mr-1">
                                                    <div class="input-group-prepend" (click)="focusFinalAmountInput()">
                                                        <span class="input-group-text" style="border:none;">₹</span>
                                                    </div>
                                                    <input #finalAmountInput formControlName="finalAmt" type="number" placeholder="0"
                                                        class="form-control" min="0"
                                                        style="text-align: right;font-weight: 800 !important;color:#212529; font-size: 18px;border:none;">
                                                </div>
                                                <div *ngIf="showFinalAmtSaveBtn" class="d-flex align-items-center justify-content-center "
                                                    style="height: 35px; width: 35px;margin:0 6px;">
                                                    <button (click)="onFinalAmountSave()"
                                                        class="btn btn-outline-secondary d-flex align-items-center justify-content-center position-relative "
                                                        style="background-color: #673AB7; color: #fff; border:1px solid #673AB7;padding: 4px 8px; ">
                                                        <i class="bi bi-bookmark"></i>
                                                        <span
                                                            class="position-absolute start-100 translate-middle badge rounded-pill"
                                                            style="font-size: 0.6rem;background-color: #fff; color: #673AB7; border:1px solid #673AB7; top:-5px; right:-5px;">
                                                            {{ counter }}
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
    
                                        </div>
    
                                        <div *ngIf="isFinalAmountEdited" class="d-flex justify-content-between"
                                            style="font-size:13px;">
                                            <div>Prev final amount: </div>
                                            <div>{{ this.prevFinalAmount | currency:'INR':'symbol':'1.2-2'}}</div>
                                        </div>
    
                                        <div *ngIf="salesDetails?.header?.RefundAmount"
                                            class="d-flex justify-content-between lead font-weight-bold text-danger">
                                            <div>Refunded Amount :</div>
                                            <div *ngIf="salesDetails?.header?.RefundAmount>0">
                                                {{ salesDetails?.header?.RefundAmount | currency:'INR':'symbol':'1.2-2'}}
                                            </div>
                                            <div *ngIf="salesDetails?.header?.RefundAmount==0">
                                                ₹ --
                                            </div>
                                        </div>
    
                                        <hr class="w-100 my-1">
    
                                        <div class="d-flex justify-content-between text-dark">
                                            <div>Current Credit Balance :</div>
                                            <div *ngIf="this.currentCreditBalance >= 0">
                                                {{ this.currentCreditBalance | currency:'INR':'symbol':'1.2-2'}}
                                            </div>
                                            <div *ngIf="this.currentCreditBalance < 0">₹ --</div>
                                        </div>
    
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="d-flex flex-column" style="gap: 0.5rem;" [ngClass]="{'access-denied': privilegeService.getServicenearPrivilege('disableCostAndPayment', false)}">
    
                            <!-- <hr class="w-100 my-1"> -->
    
                            <div *ngIf="!isPaidJob" class="d-flex justify-content-between " style="gap: 0.5rem;">
                                <button *ngIf="!isPaidJob" (click)="restoreOriginalDetails()" class=" btn btn-primary w-100"
                                    style="background-color:#fff; color:#808080; border-color:#808080;">
                                    Cancel
                                </button>
    
                                <button *ngIf="!isPaidJob" (click)="saveSelectedProducts()" class=" btn btn-primary w-100"
                                    style="background-color:#fff; color:#673AB7; border-color:#673AB7;">
                                    Save
                                </button>
                            </div>
                            <div *ngIf="!isPaidJob" class="w-100">
                                <button *ngIf="!isPaidJob" class="btn w-100" [disabled]="isAdvanceEdited"
                                    (click)="!getTotalServiceMRP() ? serviceWarningModal('checkout') : openPaymentModesModal('checkout')"
                                    style="background-color:#673AB7; color:#fff; border-color:#673AB7;"
                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('paymentEnabled', true)}">
                                    Pay & Confirm
                                </button>
                            </div>
    
                            <div *ngIf="isPaidJob && doJobHaveCredit" class="w-100">
                                <button *ngIf="isPaidJob && doJobHaveCredit" class="btn btn-success w-100"
                                    (click)="openModal()" [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('jobPayInEnabled', true)}">
                                    Pay In
                                </button>
                            </div>
    
                            <div *ngIf="isPaidJob" class="d-flex justify-content-between" style="gap: 0.5rem;">
                                <button *ngIf="isPaidJob && !isCostAndPayDisabled" (click)="restoreOriginalDetails()"
                                    class=" btn btn-primary w-100"
                                    style="background-color:#fff; color:#808080; border-color:#808080;">
                                    Cancel
                                </button>
    
                                <button *ngIf="isPaidJob && !isCostAndPayDisabled"
                                    (click)="!getTotalServiceMRP() ? serviceWarningModal('update') : openPaymentModesModal('update')"
                                    class=" btn btn-primary w-100" [ngClass]="isCostAndPayDisabled ? 'disabled-element':''"
                                    style="background-color:#673AB7; color:#fff; border-color:#673AB7;" [ngClass]="{
                                    'disabled-element': isCostAndPayDisabled,
                                    'access-denied': !privilegeService.getServicenearPrivilege('updatePaymentEnabled', true)
                                                   || privilegeService.getServicenearPrivilege('disableEditCostAndPayment', false)
                                    }">
                                    Update Payment
                                </button>
    
                                <button *ngIf="isPaidJob && isCostAndPayDisabled" (click)="isCostAndPayDisabled=false"
                                    class=" btn btn-primary w-100"
                                    style="background-color:#673AB7; color:#fff; border-color:#673AB7;"
                                    [ngClass]="{'access-denied': privilegeService.getServicenearPrivilege('disableEditCostAndPayment', false)}">
                                    Edit
                                </button>
                            </div>
    
                            <hr class="w-100 my-1">
    
                            <div class="d-flex flex-wrap" style="gap: 0.5rem;">
                                <button *ngIf="isOrderPaymentModels" class="btn btn-outline-danger"
                                    (click)="openRefundWithoutReturnModal()"
                                    style="flex: 1 1 calc(50% - 0.25rem); box-sizing: border-box;"
                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('refundEnabled', true)}">
                                    Refund
                                </button>
    
                                <button *ngIf="isOrderPaymentModels && returnProductsArray.length > 0"
                                    class="btn btn-outline-danger" (click)="openRefundWithReturnModal()"
                                    style="flex: 1 1 calc(50% - 0.25rem); box-sizing: border-box;"
                                    [ngClass]="{'access-denied': !privilegeService.getServicenearPrivilege('returnEnabled', true)}">
                                    Return
                                </button>
    
                                <button *ngIf="isOrderPaymentModels" class="btn" (click)="showOrderAgainstTransactionList()"
                                    style="flex: 1 1 calc(50% - 0.25rem); box-sizing: border-box; background-color:#fff; color:#673AB7; border-color:#673AB7;">
                                    Transaction List
                                </button>
                            </div>
    
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
        <div *ngIf="isSaleSuccess" class="modal fade show" id="exampleModalCenter" tabindex="-1"
            aria-labelledby="exampleModalCenterTitle" style="display: block; background: #00000030;" aria-modal="true"
            role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header d-flex justify-content-between">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Order Confirmation</h5>
                        <i class="bi bi-x" style="font-size: 1.5rem;" (click)="isSaleSuccess = false"></i>
                    </div>
                    <div class="modal-body text-success">
                        <p>Order Placed Successfully</p>
                        <p>Bill Number : {{successfulBillNumber}}</p>
                        <p>Order Number : {{successfulOrderNumber}}</p>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<app-pay-in *ngIf="showPayInModal" [defaultCustomer]="customerDetails" [isCustomerDisabled]="true"
    (transactionSaved)="handlePayInConfirm($event)" [JobOrderId]="this.SalesPOSOrderID"
    (close)="handlePayInClose()"></app-pay-in>

<div *ngIf="showProductEditModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{editingProductForm.get('ProductName').value}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showProductEditModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="editingProductForm">
                    <div class="form-group mb-2">
                        <label>Quantity</label>

                        <div class="input-group" style="width: 45%;">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-secondary"
                                    [disabled]="editingProductForm.get('QtyInput')?.disabled" (click)="decreaseQty()">
                                    <i class="fa fa-minus"></i>
                                </button>
                            </div>

                            <input formControlName="QtyInput" type="number" class="form-control text-center" min="1" />

                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-secondary"
                                    [disabled]="editingProductForm.get('QtyInput')?.disabled" (click)="increaseQty()">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <small class="text-danger"
                            *ngIf="editingProductForm.get('QtyInput')?.hasError('required') && editingProductForm.get('QtyInput')?.touched">
                            Quantity is required.
                        </small>
                        <small class="text-danger"
                            *ngIf="editingProductForm.get('QtyInput')?.hasError('min') && editingProductForm.get('QtyInput')?.touched">
                            Quantity must be at least 1.
                        </small>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="form-group mb-2" style="width: 45%;">
                            <label>Discount (%)</label>
                            <input formControlName="DiscountPercent" type="text" class="form-control" max="100" />
                            <small class="text-danger"
                                *ngIf="editingProductForm.get('DiscountPercent')?.hasError('min') && editingProductForm.get('DiscountPercent')?.touched">
                                Discount cannot be negative.
                            </small>
                            <small class="text-danger"
                                *ngIf="editingProductForm.get('DiscountPercent')?.hasError('max') && editingProductForm.get('DiscountPercent')?.touched">
                                Discount cannot exceed 100%.
                            </small>
                        </div>
                        <div class="form-group mb-2" style="width: 45%;">
                            <label>Discount (₹)</label>
                            <input formControlName="Discount" type="text" class="form-control"
                                [max]="editingProductForm.get('FinalPrice')?.value || 0" />
                            <small class="text-danger"
                                *ngIf="editingProductForm.get('Discount')?.hasError('min') && editingProductForm.get('Discount')?.touched">
                                Discount amount cannot be negative.
                            </small>
                            <small class="text-danger"
                                *ngIf="editingProductForm.get('Discount')?.hasError('max') && editingProductForm.get('Discount')?.touched">
                                Discount cannot exceed final price.
                            </small>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="form-group mb-2" style="width: 45%;">
                            <label>Selling Price</label>
                            <input formControlName="FinalPrice" type="text" class="form-control" />
                        </div>
                        <div class="form-group mb-2" style="width: 45%;">
                            <label>MRP</label>
                            <input formControlName="MRP" type="text" class="form-control" />
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="form-group mb-2" style="width: 45%;">
                            <label>Total Price</label>
                            <input formControlName="TotalPrice" type="text" class="form-control" readonly />
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal"
                    (click)="showProductEditModal= false">Close</button>
                <button type="button" class="btn btn-primary"
                    style="background-color:#673AB7; color:#fff; border-color:#673AB7;" (click)="isMRPEdited? showEditMRPConfirmModal() : submitProductEdit()"
                    [disabled]="editingProductForm.invalid">Save</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showRefundModal" class="modal fade show" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-scrollable" [style]="'position:absolute; top:65px; width:100%; height:calc(100% - 65px); margin:0;'">
        <div class="modal-content h-100">
            <div class="modal-header">
                <h5 class="modal-title">Return & Refund</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showRefundModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="RefundForm">

                    <div class="d-flex flex-column " *ngIf="returnProductsArray.length > 0">
                        <label>Products :</label>
                        <div *ngIf="returnProductsArray.length === 0" class="text-center text-muted small p-3">
                            No products available.
                        </div>
                        <div *ngIf="returnProductsArray.length > 0" formArrayName="returnProducts"
                            class="returnProductsList">
                            <ng-container *ngFor="let group of returnProductsArray.controls; let i = index;"
                                [formGroupName]="i">

                                <div class="d-flex flex-column rounded align-items-start text-secondary p-2 card border rounded transaction-card custom-box-shadow"
                                    style=" position: relative;font-size: 0.85rem; line-height: 1.4; margin:0 2px 8px 2px;"
                                    [ngClass]="group.get('ReturnStatus')?.value === 'Returned' ? 'bg-light disabled-product' : '' ">

                                    <div class="d-flex align-items-center justify-content-between w-100 pr-4">
                                        <div class="small text-truncate" style="font-weight: 600; width: 55%;"
                                            [ngStyle]="group.get('isSelected')?.value ? {'color':'#000'} : {'color':'#6c757d'}">
                                            {{ group.get('ProductName')?.value }}</div>

                                        <div *ngIf="group.get('ReturnStatus')?.value !== 'Returned'" class="small"
                                            style="font-weight: 600; width: 10%;">
                                            {{ group.get('TotalQuantity')?.value }}
                                        </div>

                                        <div class="small" style="font-weight: 600; width: 30%;">
                                            {{ group.get('FinalPrice')?.value|
                                            currency:
                                            'INR' }}
                                        </div>
                                    </div>

                                    <hr class="my-2 w-100">

                                    <div *ngIf="group.get('ReturnStatus')?.value !== 'Returned' "
                                        class="d-flex align-items-center justify-content-between w-100">
                                        <div class="d-flex align-items-center" style="gap:0.5rem;">
                                            <span>Rtrn Qty :</span>
                                            <div class="d-flex justify-content-center align-items-center">
                                                <div class="input-group input-group-sm" style="width: 100px;">
                                                    <div class="input-group-prepend">
                                                        <button type="button" class="btn btn-outline-secondary"
                                                            [disabled]="group.get('QtyInput')?.value <= 1"
                                                            (click)="decreaseReturnQty(i)">
                                                            <i style="font-size: 13px;" class="fa fa-minus"></i>
                                                        </button>
                                                    </div>

                                                    <input formControlName="QtyInput" type="number" min="1"
                                                        [max]="group.get('TotalQuantity')?.value"
                                                        style="font-weight: 500;" class="form-control text-center"
                                                        [ngStyle]="group.get('isSelected')?.value ? {'color':'#000'} : {'color':'#6c757d'}" />

                                                    <div class="input-group-append">
                                                        <button type="button" class="btn btn-outline-secondary"
                                                            [disabled]="group.get('QtyInput')?.value >= group.get('TotalQuantity')?.value"
                                                            (click)="increaseReturnQty(i)">
                                                            <i style="font-size: 13px;" class="fa fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center" style="gap:0.5rem;">
                                            <span>Rtrn Value :</span>
                                            <div class="small" style="font-weight: 600;"
                                                [ngStyle]="group.get('isSelected')?.value ? {'color':'#000'} : {'color':'#6c757d'}">
                                                {{ group.get('QtyInput')?.hasError('max')
                                                ? '--'
                                                : (group.get('FinalPrice')?.value * group.get('QtyInput')?.value |
                                                currency:'INR')}}
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="group.get('ReturnStatus')?.value === 'Returned' "
                                        class="d-flex align-items-center justify-content-end w-100">
                                        <div class="small text-danger" style="font-weight: 600;">
                                            Returned
                                        </div>
                                    </div>

                                    <small class="text-danger mt-2"
                                        *ngIf="group.get('QtyInput')?.hasError('max') && group.get('QtyInput')?.touched">
                                        Quantity cannot exceed {{ group.get('TotalQuantity')?.value }}.
                                    </small>

                                    <div class="d-flex justify-content-center align-items-center"
                                        style="position: absolute; top: 7px; right: 7px;">
                                        <input class="return-checkbox" type="checkbox" formControlName="isSelected" />
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="returnProductsArray.length > 0" class="d-flex justify-content-between mt-3">
                        <div class="d-flex align-items-center" style="gap: 0.5rem;">Rtrng Qty: <span
                                style="font-weight: 600;">{{ RefundForm.invalid ? '--' : selectedReturnTotals.quantity
                                }}</span></div>
                        <div class="d-flex align-items-center" style="gap: 0.5rem;">Rtrng Amt: <span
                                style="font-weight: 600;">{{ RefundForm.invalid ? '--' : (selectedReturnTotals.amount |
                                currency:'INR':'symbol':'1.2-2') }}</span></div>
                    </div>

                    <hr class="my-y w-100">

                    <div class="d-flex align-items-center" style="gap: 1rem;">
                        <input class="return-checkbox" type="checkbox" formControlName="isRefundWithReturn" />
                        <label class="mb-0">Do you want to refund?</label>
                    </div>

                    <div *ngIf="RefundForm.get('isRefundWithReturn').value" class="form-group my-3">
                        <label for="amount">Refund Amount :</label>
                        <input type="number" id="amount" class="form-control" placeholder="Enter Amount (₹)"
                            formControlName="amount" />
                        <small *ngIf="RefundForm.get('amount')?.hasError('max') && RefundForm.get('amount')?.touched"
                            class="text-danger">
                            Amount exceeds the max paid by customer.
                        </small>
                        <small *ngIf="!isReturnProductsSelected" class="text-danger">
                            Select at least one product to return & refund.
                        </small>
                    </div>
                    <div *ngIf="RefundForm.get('isRefundWithReturn').value" class="form-group mb-4 ">
                        <label for="amount">Payment :</label>
                        <button class="btn btn-primary form-control"
                            [disabled]="RefundForm.invalid || !isReturnProductsSelected"
                            style="background-color:#fff; color:#808080; border-color:#808080;"
                            (click)="openPaymentModesModal('return')">Select</button>
                    </div>
                </form>

                <hr class="my-y w-100">

                <div class="d-flex justify-content-end" style="gap: 0.5rem; justify-content: end;">
                    <button class="btn btn-outline-secondary" style="width: 40%;"
                        (click)="resetReturnProducts()">Cancel</button>
                    <button class="btn btn-primary" (click)="handleReturnWithoutRefund()"
                        [disabled]="RefundForm.get('isRefundWithReturn').value || RefundForm.invalid || !isReturnProductsSelected"
                        style="background-color:#673AB7; color:#fff; border-color:#673AB7;width: 60%;">Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showRefundWithoutReturnModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Refund</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showRefundWithoutReturnModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="RefundForm">

                    <div class="form-group my-3">
                        <label for="amount">Refund Amount :</label>
                        <input type="number" id="amount" class="form-control" placeholder="Enter Amount (₹)"
                            formControlName="amount" />
                        <small *ngIf="RefundForm.get('amount')?.hasError('max') && RefundForm.get('amount')?.touched"
                            class="text-danger">
                            Amount exceeds the max paid by customer.
                        </small>
                    </div>
                    <div class="form-group mb-4 ">
                        <label for="amount">Payment :</label>
                        <button class="btn btn-primary form-control"
                            [disabled]="RefundForm.get('amount')?.hasError('max') || RefundForm.get('amount')?.value <=0"
                            style="background-color:#fff; color:#808080; border-color:#808080;"
                            (click)="openPaymentModesModal('refund')">Select</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>


<div *ngIf="showEditAdvanceModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edit Advance</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showEditAdvanceModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="billForm">

                    <div class="form-group mb-4">
                        <label for="amount">New Advance Amount :</label>
                        <input type="number" id="amount" class="form-control" placeholder="Enter Amount (₹)"
                            formControlName="newAdvance" />
                    </div>
                    <div class="form-group mb-4 ">
                        <label for="amount">Payment :</label>
                        <button class="btn btn-primary form-control"
                            style="background-color:#fff; color:#808080; border-color:#808080;"
                            (click)="this.prevAdvanceAmount >0 ? openPaymentModesModal('edit-advance') : openPaymentModesModal('add-advance')">Select</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>

<app-payment-methods *ngIf="showPaymentModesModal" [totalReceivable]="finalAmount" [calledFrom]="calledFrom"
    [prevPayInfo]="prevPaymentInfo" [advanceEditAmount]="billForm.get('newAdvance')?.value" [isPaidJob]="isPaidJob"
    [refundAmount]="refundAmount" (close)="handlePaymentModalClose()"
    (paymentSaved)="handlePaymentSaved($event)"></app-payment-methods>


<div *ngIf="showQuickAddProductForm" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Create Product</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="onCloseQuickProductAddForm()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <!-- Quick Create Product Form -->
                <div class="quick-add-product-form mt-2">
                    <form [formGroup]="quickAddProductForm">
                        <div class="d-flex flex-column" style="gap: 0.5rem;">
                            <div>
                                <div class="d-flex flex-column mb-2">
                                    <div class="">
                                        <label>Product Name*</label>
                                        <input formControlName="ProductName" class="form-control" />
                                    </div>
                                    <small class="text-danger"
                                        *ngIf="quickAddProductForm.get('ProductName')?.hasError('required') && quickAddProductForm.get('ProductName')?.touched">
                                        Product name is required.
                                    </small>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex flex-column mb-2" style="width: 45%;">
                                        <div class="form-group">
                                            <label>Quantity*</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-secondary"
                                                        (click)="decreaseQuickProductQty()">
                                                        <i class="fa fa-minus"></i>
                                                    </button>
                                                </div>

                                                <input type="number" formControlName="QtyInput"
                                                    class="form-control text-center" min="1" />

                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-outline-secondary"
                                                        (click)="increaseQuickProductQty()">
                                                        <i class="fa fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <small class="text-danger"
                                            *ngIf="quickAddProductForm.get('QtyInput')?.hasError('required') && quickAddProductForm.get('QtyInput')?.touched">
                                            Quantity is required.
                                        </small>
                                        <small class="text-danger"
                                            *ngIf="quickAddProductForm.get('QtyInput')?.hasError('min') && quickAddProductForm.get('QtyInput')?.touched">
                                            Quantity must be at least 1.
                                        </small>
                                    </div>
                                    <div class="d-flex flex-column mb-2" style="width: 45%;">
                                        <div class="form-group">
                                            <label>{{ showMoreFields ? 'Final Price* :' : 'Price* :' }}</label>
                                            <input type="number" formControlName="FinalPrice" class="form-control"
                                                min="0" />
                                        </div>
                                        <small class="text-danger"
                                            *ngIf="quickAddProductForm.get('FinalPrice')?.hasError('required') && quickAddProductForm.get('FinalPrice')?.touched">
                                            Final price is required.
                                        </small>
                                        <small class="text-danger" *ngIf="quickAddProductForm.get('UnitPrice')?.hasError('finalGreaterThanMRP')">
                                            Final Price cannot be greater than MRP.
                                        </small>
                                        <small class="text-danger"
                                            *ngIf="quickAddProductForm.get('FinalPrice')?.hasError('finalGreaterThanUnitPrice')">
                                            Final Price cannot be less than Sales Price.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="showMoreFields">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex flex-column mb-2" style="width: 45%;">
                                        <div class="form-group">
                                            <label>Sales Price*</label>
                                            <input type="number" formControlName="UnitPrice" class="form-control" min="0" />
                                        </div>
                                        <small class="text-danger"
                                            *ngIf="quickAddProductForm.get('UnitPrice')?.hasError('required') && quickAddProductForm.get('UnitPrice')?.touched">
                                            SalesPrice price is required.
                                        </small>
                                        <small class="text-danger" *ngIf="quickAddProductForm.get('UnitPrice')?.hasError('unitGreaterThanMRP')">
                                            Sales Price cannot be greater than MRP.
                                        </small>
                                    </div>
                                    <div class="d-flex flex-column mb-2" style="width: 45%;">
                                        <div class="form-group">
                                            <label>MRP</label>
                                            <input type="number" formControlName="MRP" class="form-control" min="0" />
                                        </div>
                                        <small *ngIf="quickAddProductForm.errors?.finalPriceGreaterThanMRP && quickAddProductForm.get('MRP')?.touched"
                                            class="text-danger">
                                            Selling Price must be less than MRP.
                                        </small>
                                        <small class="text-danger" *ngIf="quickAddProductForm.get('MRP')?.hasError('unitGreaterThanMRP')">
                                            MRP cannot be less than Sales Price.
                                        </small>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-start">
                                    <div class="form-group mb-2" style="width: 45%;">
                                        <label>Purchase Price</label>
                                        <input type="number" formControlName="PurchasePrice" class="form-control" min="0" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="form-group mb-0" style="width: 45%;">
                                        <label>Disc On Sales (₹)</label>
                                        <input type="number" formControlName="Discount" class="form-control" min="0" />
                                    </div>
                                    <div class="form-group mb-0" style="width: 45%;">
                                        <label>Disc On Sales (%)</label>
                                        <input type="number" formControlName="DiscountPercent" class="form-control"
                                            min="0" max="100" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end">
                                    <div class="form-group mb-2" style="width: 100%;">
                                        <div class="custom-disc-line text-right">
                            Customer Display Disc. (on MRP):
                            <span class="custom-disc-line-value">
                                {{ quickAddProductForm.get('mrpDiscountPercent')?.value }}% /
                                ₹ {{ quickAddProductForm.get('mrpDiscount')?.value }}
                            </span>
                        </div>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn btn-link p-0" (click)="toggleMoreFields()">
                                {{ showMoreFields ? 'Hide' : 'More' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="modal-footer">
                <div class="d-flex justify-content-end mt-2" style="gap: 0.5rem;">
                    <button type="button" class="btn btn-outline-secondary"
                        (click)="cancelQuickAddProduct()">Cancel</button>
                    <button type="button" class="btn btn-primary" [disabled]="quickAddProductForm.invalid"
                        style="background-color: #673AB7; color: #fff; border: #673AB7;"
                        (click)="saveQuickAddProduct()">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showServiceWarningModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">No Service Charges Added</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showServiceWarningModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <p>No service charges have been added. Do you want to continue?</p>
            </div>
            <div class="modal-footer">
                <button type="button" id="btnAddServices" class="btn btn-outline-secondary" data-dismiss="modal"
                    (click)="onAddServicesClick();showServiceWarningModal = false;">Add Services</button>
                <button type="button" id="btnContinue" class="btn btn-primary"
                    style="background-color: #673AB7; color: #fff; border: #673AB7;"
                    (click)="handleServiceWarningContinue()">Continue</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showMRPEditWarningModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edited MRP</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showMRPEditWarningModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <p>MRP has been edited. Do you want to continue?</p>
            </div>
            <div class="modal-footer">
                <button type="button" id="btnAddServices" class="btn btn-outline-secondary" data-dismiss="modal"
                    (click)="showMRPEditWarningModal = false;">Cancel</button>
                <button type="button" id="btnContinue" class="btn btn-primary"
                    style="background-color: #673AB7; color: #fff; border: #673AB7;"
                    (click)="submitProductEdit();showMRPEditWarningModal = false;">Continue</button>
            </div>
        </div>
    </div>
</div>